import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { components } from 'react-select';
import DInputCheck from '../../DInputCheck';
export default function DSelectOptionCheck(_a) {
    var { innerProps, children, isSelected } = _a, props = __rest(_a, ["innerProps", "children", "isSelected"]);
    return (_jsx(components.Option, Object.assign({ className: classNames({
            'd-select__option': true,
            'd-select__option--is-checkbox': true,
        }), isSelected: isSelected, innerProps: innerProps }, props, { children: _jsxs("label", { htmlFor: `${innerProps.id}Check`, children: [_jsx(DInputCheck, { type: "checkbox", checked: isSelected, id: `${innerProps.id}Check` }), children] }) })));
}
//# sourceMappingURL=DSelectOptionCheck.js.map